export default __webpack_public_path__ + "static/media/McKinsey.38f30d51.png";